import React from "react";
import { VideoJsPlayer } from "video.js";
import { IPlayerConfig } from "models/player-config.model";
import { IMedia } from "models/media.model";
import ReactDOM from "react-dom/client";
import ShareFullScreenButton from "components/ShareFullScreenButton/ShareFullScreenButton";


interface IFullScreenCustomizeProps {
  player: VideoJsPlayer;
  config: IPlayerConfig;
  currentMedia: IMedia;
  shareId: string;
  page: 'share' | 'embed'
}

export function FullScreenCustomize({player, config, currentMedia, shareId, page }: IFullScreenCustomizeProps): void{


  const shareButtonContainer = document.createElement('div');

  const isShareable =
    config.player?.enable_embed_code ||
    (config.player?.enable_facebook && config.player?.facebook_back_link !== "") ||
    (config.player?.enable_twitter && config.player?.twitter_back_link !== "");

  if (player.isFullscreen()) {
    shareButtonContainer.className = 'share-button-container';

    if(isShareable) {
      player.el().appendChild(shareButtonContainer);
    }

    ReactDOM.createRoot(shareButtonContainer).render(<ShareFullScreenButton shareId={shareId}/>);

  } else {

    const chapterButton = document.getElementById('chapters-fullscreen-btn');
    const shareButton = document.getElementById('share-fullscreen-btn');


    if(chapterButton) {
      chapterButton.remove();
    }

    if(shareButton) {
      shareButton.remove();
    }
  }


}
